'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _reverse2 = require('lodash/reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _clamp2 = require('lodash/clamp');

var _clamp3 = _interopRequireDefault(_clamp2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _take2 = require('lodash/take');

var _take3 = _interopRequireDefault(_take2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ChartShowMoreToggle = require('components/ChartShowMoreToggle/ChartShowMoreToggle');

var _ChartShowMoreToggle2 = _interopRequireDefault(_ChartShowMoreToggle);

var _Chart = require('components/Chart/Chart');

var _Chart2 = _interopRequireDefault(_Chart);

var _qim = require('qim');

var _chart = require('helpers/chart');

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _ChartNoData = require('components/Statistics/ChartNoData/ChartNoData');

var _ChartNoData2 = _interopRequireDefault(_ChartNoData);

var _chartColors = require('components/Chart/chart-colors');

var _chartColors2 = _interopRequireDefault(_chartColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ChartWrapper.scss');

var ChartWrapper = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ChartWrapper, _PureComponent);

  function ChartWrapper() {
    var _ref;

    (0, _classCallCheck3.default)(this, ChartWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChartWrapper.__proto__ || (0, _getPrototypeOf2.default)(ChartWrapper)).call.apply(_ref, [this].concat(args)));

    var isHasMoreData = _this.hasMoreData(args[0]);
    _this.state = { showMoreToggle: isHasMoreData, showAllData: !isHasMoreData };
    return _this;
  }

  (0, _createClass3.default)(ChartWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isHasMoreData = this.hasMoreData(nextProps);
      this.setState({ showMoreToggle: isHasMoreData, showAllData: !isHasMoreData });
    }
  }, {
    key: 'onShowMore',
    value: function onShowMore() {
      var showAllData = this.state.showAllData;

      this.setState({ showAllData: !showAllData });
      this.props.onShowMore(!showAllData);
    }
  }, {
    key: 'getDataPartition',
    value: function getDataPartition() {
      var _props = this.props,
          data = _props.chartProps.data,
          limit = _props.limit;

      var partSize = limit + 1; // +1 to include header
      var isHasMoreData = this.hasMoreData();
      var showAllData = this.state.showAllData;

      return showAllData || !isHasMoreData ? data : (0, _take3.default)(data, partSize);
    }
  }, {
    key: 'getChartProps',
    value: function getChartProps() {
      var _props2 = this.props,
          chartProps = _props2.chartProps,
          itemHeight = _props2.itemHeight,
          height = _props2.height,
          minHeight = _props2.minHeight,
          legendHeight = _props2.legendHeight,
          showScale = _props2.showScale,
          scaleHeight = _props2.scaleHeight,
          reverseColors = _props2.reverseColors;

      var data = this.getDataPartition();
      var areaHeight = (0, _clamp3.default)(height || data.length * itemHeight, minHeight, Infinity);
      var showLegend = (0, _get3.default)(chartProps, 'options.legend.position') !== _chart.chartLegendPosition.none;
      var chartHeight = areaHeight - (showLegend ? legendHeight : 0) - (showScale ? scaleHeight : 0);
      var colors = reverseColors ? (0, _reverse3.default)([].concat((0, _toConsumableArray3.default)(_chartColors2.default))) : [].concat((0, _toConsumableArray3.default)(_chartColors2.default));

      return (0, _qim.update)([['data', (0, _qim.$set)(data)], ['height', (0, _qim.$set)(areaHeight + 'px')], ['options', ['height', (0, _qim.$set)(areaHeight)], ['chartArea', 'height', (0, _qim.$set)(chartHeight)], ['colors', (0, _qim.$set)(colors)]]], chartProps);
    }
  }, {
    key: 'hasMoreData',
    value: function hasMoreData() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var data = props.chartProps.data,
          limit = props.limit;

      var partSize = limit + 1; // +1 to include header
      return !!limit && data.length > partSize;
    }
  }, {
    key: 'render',
    value: function render() {
      var chartProps = this.getChartProps();
      var _props3 = this.props,
          className = _props3.className,
          loading = _props3.loading,
          _props3$hasData = _props3.hasData,
          hasData = _props3$hasData === undefined ? chartProps.data.length > 1 : _props3$hasData;


      if (loading) {
        return _react2.default.createElement(_Loader2.default, { alignCenter: true });
      } else if (!hasData) {
        return _react2.default.createElement(_ChartNoData2.default, null);
      }

      var _state = this.state,
          showMoreToggle = _state.showMoreToggle,
          showAllData = _state.showAllData;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.wrapper, className) },
        _react2.default.createElement(_Chart2.default, chartProps),
        showMoreToggle && _react2.default.createElement(_ChartShowMoreToggle2.default, {
          onClick: this.onShowMore,
          isOpen: showAllData
        })
      );
    }
  }]);
  return ChartWrapper;
}(_react.PureComponent), _class2.propTypes = {
  chartProps: _propTypes2.default.object,
  className: _propTypes2.default.string,
  hasData: _propTypes2.default.bool,
  height: _propTypes2.default.number,
  itemHeight: _propTypes2.default.number,
  legendHeight: _propTypes2.default.number,
  limit: _propTypes2.default.number,
  loading: _propTypes2.default.bool,
  minHeight: _propTypes2.default.number,
  onShowMore: _propTypes2.default.func,
  reverseColors: _propTypes2.default.bool,
  scaleHeight: _propTypes2.default.number,
  showScale: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  chartProps: {},
  height: 0,
  itemHeight: 40,
  legendHeight: 40,
  scaleHeight: 20,
  limit: 0,
  minHeight: 30,
  onShowMore: _noop3.default,
  reverseColors: false
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onShowMore', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onShowMore'), _class.prototype)), _class);
exports.default = ChartWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChartWrapper/ChartWrapper.js
// module id = 211
// module chunks = 1